// Turns tokens.js into a flat map of --ft-* CSS custom properties so plain CSS,
// Syncfusion and Bryntum read the same values as the MUI theme.

const kebab = (str) => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

// Group key -> CSS name prefix ('' drops the group name from the variable).
const GROUP_PREFIX = {
  neutrals: '',
  primary: 'primary',
  tones: 'tone',
  category: 'category',
  series: 'series',
  fontWeights: 'font-weight',
  radius: 'radius',
  motion: 'motion',
};

const UNIT_SUFFIX = { radius: 'px', motion: 'ms' };

const SKIP_GROUPS = ['type'];

const flatten = (obj, path, unit, out) => {
  Object.entries(obj).forEach(([key, value]) => {
    const nextPath = [...path, kebab(key)];
    if (value && typeof value === 'object') {
      flatten(value, nextPath, unit, out);
    } else {
      out[`--ft-${nextPath.filter(Boolean).join('-')}`] = unit
        ? `${value}${unit}`
        : String(value);
    }
  });
};

export function tokensToCssVars(tokens) {
  const vars = {};
  Object.entries(tokens).forEach(([group, value]) => {
    if (SKIP_GROUPS.includes(group)) return;
    if (value && typeof value === 'object') {
      const prefix = group in GROUP_PREFIX ? GROUP_PREFIX[group] : kebab(group);
      flatten(value, [prefix], UNIT_SUFFIX[group], vars);
    } else {
      vars[`--ft-${kebab(group)}`] = String(value);
    }
  });
  return vars;
}

export default tokensToCssVars;
